import { Sparkles, Aperture, Clock, Users } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";
import { WHY_US } from "../data/siteContent";

const ICONS = { Sparkles, Aperture, Clock, Users };

export default function WhyChooseUs() {
  return (
    <section data-testid="why-us-section" className="py-20 sm:py-28 lg:py-32 bg-ink-soft/30 border-y border-white/[0.05]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionHeading
          eyebrow="Why Mohit Studio"
          title={
            <>
              Why families <span className="italic text-gold">trust us</span> with their biggest day
            </>
          }
        />

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-10">
          {WHY_US.map((w, i) => {
            const Icon = ICONS[w.icon];
            return (
              <Reveal key={w.title} delay={i * 0.1}>
                <div className="flex flex-col items-center text-center gap-5" data-testid={`why-us-item-${i + 1}`}>
                  <div className="relative">
                    <span className="absolute inset-0 rounded-full border border-gold/25 scale-100 group-hover:scale-110 transition-transform" />
                    <div className="w-20 h-20 rounded-full border border-gold/40 bg-ink flex items-center justify-center text-gold">
                      <Icon className="w-7 h-7" strokeWidth={1.4} />
                    </div>
                  </div>
                  <h3 className="font-display text-xl sm:text-2xl text-ivory">{w.title}</h3>
                  <p className="text-sm text-ivory-dim/85 leading-relaxed max-w-[26ch]">{w.desc}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
